import './compressedTextureExtensions.mjs';
export { detectCompressedTextures } from './detectCompressedTextures.mjs';
export { loadDDS } from './loadDDS.mjs';
export { loadKTX } from './loadKTX.mjs';
export { resolveCompressedTextureUrl } from './resolveCompressedTextureUrl.mjs';
//# sourceMappingURL=index.mjs.map
